import script from "./EditPrivateEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPrivateEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./EditPrivateEmailModal.vue?vue&type=style&index=0&id=78e80a7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e80a7a"]])

export default __exports__